import { FC } from "react";

interface ClockProps {
  color?: string;
  size?: number;
}

const Clock: FC<ClockProps> = ({ color = "black", size = 24 }) => {
  return (
    
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.991 0C4.023 0 0 4.032 0 9C0 13.968 4.023 18 8.991 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 8.991 0ZM9 16.2C5.022 16.2 1.8 12.978 1.8 9C1.8 5.022 5.022 1.8 9 1.8C12.978 1.8 16.2 5.022 16.2 9C16.2 12.978 12.978 16.2 9 16.2ZM9.45 5.175C9.45 4.80221 9.14779 4.5 8.775 4.5C8.40221 4.5 8.1 4.80221 8.1 5.175V9.9L12.2744 12.4047C12.5791 12.5875 12.9743 12.4902 13.1593 12.1868C13.3468 11.8793 13.2469 11.4778 12.9371 11.294L9.45 9.225V5.175Z" fill={color}/>
    </svg>

  );
};

export default Clock;
